import { useTranslation } from 'react-i18next';
import { avatars } from '@/config/siteImages';

export default function CredibilitySection() {
  const { t } = useTranslation();

  const stats = [
    { valueKey: 'stat_1_value', labelKey: 'stat_1_label', icon: 'ri-funds-box-line' },
    { valueKey: 'stat_2_value', labelKey: 'stat_2_label', icon: 'ri-store-2-line' },
    { valueKey: 'stat_3_value', labelKey: 'stat_3_label', icon: 'ri-time-line' },
    { valueKey: 'stat_4_value', labelKey: 'stat_4_label', icon: 'ri-user-star-line' },
  ];

  return (
    <section className="py-24 bg-[#F8F3FB] px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left: Testimonial */}
          <div>
            <p className="text-xs font-semibold text-[#4F2D63] uppercase tracking-widest mb-4">
              Trusted &amp; Proven
            </p>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight">
              {t('credibility_title')}
            </h2>
            <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-md">
              {t('credibility_subtitle')}
            </p>

            <div className="bg-white border border-[#E9D9F2] rounded-2xl p-7">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <blockquote className="text-gray-700 text-base leading-relaxed italic mb-6">
                &ldquo;The team at Kailac walked me through every step with complete transparency. Professional, fast, and genuinely helpful.&rdquo;
              </blockquote>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={avatars.small.credLatino}
                    alt="Business owner testimonial"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">David M.</p>
                  <p className="text-xs text-gray-400">E-Commerce Owner, Miami FL</p>
                  <p className="text-xs font-semibold text-[#0F766E] mt-0.5">$92K in Funding Accessed*</p>
                </div>
              </div>
              <p className="text-xs text-gray-400 italic mt-4 pt-4 border-t border-[#E9D9F2]">
                *Individual results may vary. Subject to eligibility.
              </p>
            </div>
          </div>

          {/* Right: Stats Grid */}
          <div>
            <div className="grid grid-cols-2 gap-4 mb-6">
              {stats.map(({ valueKey, labelKey, icon }) => (
                <div
                  key={valueKey}
                  className="bg-white border border-[#E9D9F2] rounded-2xl p-6"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#F8F3FB] mb-3">
                    <i className={`${icon} text-[#4F2D63] text-base`}></i>
                  </div>
                  <p className="text-3xl font-bold text-gray-900 mb-1">{t(valueKey)}</p>
                  <p className="text-xs text-gray-500">{t(labelKey)}</p>
                </div>
              ))}
            </div>
            <p className="text-xs text-gray-400 italic text-center mb-5">
              Cumulative guided applicant results since 2009. Individual results may vary.
            </p>

            {/* Authority Panel */}
            <div className="bg-white border border-[#E9D9F2] rounded-2xl p-6">
              <div className="grid grid-cols-3 gap-4">
                {[
                  { icon: 'ri-shield-star-line', text: 'Compliance-First', color: 'text-[#4F2D63]' },
                  { icon: 'ri-group-2-line', text: 'Human Advisors', color: 'text-amber-500' },
                  { icon: 'ri-global-line', text: 'EN / ES Support', color: 'text-[#4F2D63]' },
                  { icon: 'ri-lock-2-line', text: 'Secure Process', color: 'text-amber-500' },
                  { icon: 'ri-file-check-line', text: 'Transparent Fees', color: 'text-[#0F766E]' },
                  { icon: 'ri-customer-service-2-line', text: 'Expert Guided', color: 'text-[#0F766E]' },
                ].map(({ icon, text, color }) => (
                  <div key={text} className="flex flex-col items-center text-center gap-1.5 py-2">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                      <i className={`${icon} ${color} text-xl`}></i>
                    </div>
                    <span className="text-xs text-gray-500 leading-tight">{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
